// Token Auth
export const TOKEN_AUTH_REQUEST = 'TOKEN_AUTH_REQUEST';
export const TOKEN_AUTH_DONE = 'TOKEN_AUTH_DONE';
export const TOKEN_AUTH_FAILED = 'TOKEN_AUTH_FAILED';
